import { useQuery } from '@apollo/client/react';

import { GET_USER_NOTIFICATION_SETTINGS } from '@modules/notifications/notificationQueries';
import {
  getNotificationUserFacts,
  isNotificationEligible,
} from '@modules/notifications/notificationVisibility';
import { groupNotificationsByModule } from '@modules/notifications/preferences/notificationGroups';

// The notifications this user may receive, grouped by module, in the same
// order as the preferences drawer.
export const useUserNotificationSettings = (
  userId: string,
  { skip = false }: { skip?: boolean } = {},
) => {
  const query = useQuery(GET_USER_NOTIFICATION_SETTINGS, {
    variables: { userId },
    skip,
  });
  const user = query.data?.users_by_pk ?? null;
  const userFacts = user == null ? null : getNotificationUserFacts(user);
  const groups =
    userFacts == null
      ? []
      : groupNotificationsByModule(
          (query.data?.notification_settings ?? []).filter(setting =>
            isNotificationEligible(setting, userFacts),
          ),
          userFacts.moduleIds,
        );

  return {
    query,
    user,
    groups,
    settings: groups.flatMap(group => group.settings),
    hasPhoneNumber: (user?.phone_numbers.length ?? 0) > 0,
    hasProApp: (user?.pro_app_tokens.length ?? 0) > 0,
  };
};
